module.exports = __webpack_public_path__ + "static/media/sep-2022.728b4ab0.svg";